import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

// Context providers
import { CourseProgressProvider } from "./contexts/CourseProgressContext";

// Layout components
import Footer from "./components/layout/Footer";
import Header from "./components/layout/Header";

// Page components
import Home from "./pages/Home";
import WhyItMatters from "./pages/WhyItMatters";
import CaseStudies from "./pages/CaseStudies";
import CarbonFootprint from "./pages/CarbonFootprint";
import Quiz from "./pages/Quiz";
import ActionToolkit from "./pages/ActionToolkit";
import FurtherLearning from "./pages/FurtherLearning";
import ClimateEngine from "./pages/ClimateEngine";
import CarbonEmissions101 from "./pages/CarbonEmissions101";
import UAECarbonDay from "./pages/UAECarbonDay";

function App() {
  return (
    <CourseProgressProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/why-it-matters" element={<WhyItMatters />} />
              <Route path="/climate-engine" element={<ClimateEngine />} />
              <Route
                path="/carbon-emissions-101"
                element={<CarbonEmissions101 />}
              />
              <Route path="/uae-carbon-day" element={<UAECarbonDay />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/carbon-footprint" element={<CarbonFootprint />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/action-toolkit" element={<ActionToolkit />} />
              <Route path="/further-learning" element={<FurtherLearning />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </CourseProgressProvider>
  );
}

export default App;
